import services from '@/services'

let executingWaitingMessage = false

export const executeWaitingMessage = async context => {
  if (!executingWaitingMessage) {
    executingWaitingMessage = true

    services.room
      .executeRules(context.getters.chatKey, 'waiting-message')
      .then(() => (executingWaitingMessage = false))
      .catch(() => (executingWaitingMessage = false))
  }
}
